import type { SVGProps } from "react";

export const MicrosoftExcel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-name="Слой 1"
    viewBox="0 0 486 500"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Microsoft Excel</title>
    <defs>
      <radialGradient
        cx="-746.66"
        cy="781.44"
        data-name="Безымянный градиент"
        fx="-746.66"
        fy="781.44"
        gradientTransform="matrix(-28.32596 -29.80763 -23.11916 21.97986 -2596.39 -38900.31)"
        gradientUnits="userSpaceOnUse"
        id="microsoft_excel__a"
        r="13.89"
      >
        <stop offset=".06" stopColor="#379539" />
        <stop offset=".42" stopColor="#297c2d" />
        <stop offset=".7" stopColor="#15561c" />
      </radialGradient>
      <radialGradient
        cx="-773.19"
        cy="771.25"
        data-name="Безымянный градиент 2"
        fx="-773.19"
        fy="771.25"
        gradientTransform="matrix(-11.97612 -11.58137 -8.95853 9.26806 -2155.12 -15858.88)"
        gradientUnits="userSpaceOnUse"
        id="microsoft_excel__b"
        r="13.89"
      >
        <stop offset="0" stopColor="#073b10" />
        <stop offset=".99" stopColor="#084a13" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        cx="-824.11"
        cy="810.99"
        data-name="Безымянный градиент 6"
        fx="-824.11"
        fy="810.99"
        gradientTransform="matrix(-9.02 0 0 19.09 -7120.4 -15378.69)"
        gradientUnits="userSpaceOnUse"
        id="microsoft_excel__f"
        r="13.89"
      >
        <stop offset=".29" stopColor="#4eb43b" />
        <stop offset="1" stopColor="#72cc61" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        cx="-769.14"
        cy="808.9"
        data-name="Безымянный градиент 8"
        fx="-769.14"
        fy="808.9"
        gradientTransform="matrix(-16.9077 -13.68182 13.64112 -16.86345 -23523.37 3309.71)"
        gradientUnits="userSpaceOnUse"
        id="microsoft_excel__h"
        r="13.89"
      >
        <stop offset=".44" stopColor="#79e96d" />
        <stop offset="1" stopColor="#d0eb76" />
      </radialGradient>
      <radialGradient
        cx="-675.64"
        cy="793.28"
        data-name="Безымянный градиент 9"
        fx="-675.64"
        fy="793.28"
        gradientTransform="matrix(15.99196 15.99755 45.54153 -45.54797 -25315.85 47178.18)"
        gradientUnits="userSpaceOnUse"
        id="microsoft_excel__i"
        r="13.89"
      >
        <stop offset="0" stopColor="#20a85e" />
        <stop offset=".94" stopColor="#09442a" />
      </radialGradient>
      <radialGradient
        cx="-657.62"
        cy="853.99"
        data-name="Безымянный градиент 10"
        fx="-657.62"
        fy="853.99"
        gradientTransform="matrix(0 11.2 12.9 0 -10902.85 7734.8)"
        gradientUnits="userSpaceOnUse"
        id="microsoft_excel__j"
        r="13.89"
      >
        <stop offset=".58" stopColor="#33a662" stopOpacity={0} />
        <stop offset=".97" stopColor="#98f0b0" />
      </radialGradient>
      <linearGradient
        data-name="Безымянный градиент 3"
        gradientTransform="matrix(1 0 0 -1 0 502)"
        gradientUnits="userSpaceOnUse"
        id="microsoft_excel__c"
        x1="69.43"
        x2="260.84"
        y1="210.33"
        y2="210.33"
      >
        <stop offset="0" stopColor="#52d17c" />
        <stop offset=".33" stopColor="#4aa647" />
      </linearGradient>
      <linearGradient
        data-name="Безымянный градиент 4"
        gradientTransform="matrix(1 0 0 -1 0 502)"
        gradientUnits="userSpaceOnUse"
        id="microsoft_excel__d"
        x1="194.4"
        x2="194.4"
        y1="335.33"
        y2="161.68"
      >
        <stop offset="0" stopColor="#29852f" />
        <stop offset=".5" stopColor="#4aa647" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        data-name="Безымянный градиент 5"
        gradientTransform="matrix(1 0 0 -1 0 502)"
        gradientUnits="userSpaceOnUse"
        id="microsoft_excel__e"
        x1="80.49"
        x2="311.45"
        y1="297.22"
        y2="497.54"
      >
        <stop offset="0" stopColor="#66d052" />
        <stop offset="1" stopColor="#85e972" />
      </linearGradient>
      <linearGradient
        data-name="Безымянный градиент 7"
        gradientTransform="matrix(1 0 0 -1 0 502)"
        gradientUnits="userSpaceOnUse"
        id="microsoft_excel__g"
        x1="182.11"
        x2="69.43"
        y1="377"
        y2="377"
      >
        <stop offset=".18" stopColor="#c0e075" stopOpacity={0} />
        <stop offset="1" stopColor="#d1eb95" />
      </linearGradient>
    </defs>
    <path
      d="M69.43 159.72c0-34.52 27.98-62.5 62.49-62.5h354.09v361.11c0 23.01-18.65 41.67-41.66 41.67H152.74c-46.01 0-83.31-37.31-83.31-83.33V159.72Z"
      style={{ fill: "url(#microsoft_excel__a)" }}
    />
    <path
      d="M69.43 159.72c0-34.52 27.98-62.5 62.49-62.5h354.09v361.11c0 23.01-18.65 41.67-41.66 41.67H152.74c-46.01 0-83.31-37.31-83.31-83.33V159.72Z"
      style={{ fill: "url(#microsoft_excel__b)", fillOpacity: 0.7 }}
    />
    <path
      d="M69.43 229.17c0-34.52 27.98-62.5 62.49-62.5h187.46c-23.01 0-41.66 18.66-41.66 41.67v83.33c0 23.01-18.65 41.67-41.66 41.67h-83.31c-46.01 0-83.31 37.31-83.31 83.33v-187.5Z"
      style={{ fill: "url(#microsoft_excel__c)" }}
    />
    <path
      d="M69.43 229.17c0-34.52 27.98-62.5 62.49-62.5h187.46c-23.01 0-41.66 18.66-41.66 41.67v83.33c0 23.01-18.65 41.67-41.66 41.67h-83.31c-46.01 0-83.31 37.31-83.31 83.33v-187.5Z"
      style={{ fill: "url(#microsoft_excel__d)", fillOpacity: 0.3 }}
    />
    <path
      d="M69.43 83.33C69.43 37.31 106.73 0 152.74 0h166.63v166.67H152.74c-46.01 0-83.31 37.31-83.31 83.33V83.33Z"
      style={{ fill: "url(#microsoft_excel__e)" }}
    />
    <path
      d="M69.43 83.33C69.43 37.31 106.73 0 152.74 0h166.63v166.67H152.74c-46.01 0-83.31 37.31-83.31 83.33V83.33Z"
      style={{ fill: "url(#microsoft_excel__f)" }}
    />
    <path
      d="M69.43 83.33C69.43 37.31 106.73 0 152.74 0h166.63v166.67H152.74c-46.01 0-83.31 37.31-83.31 83.33V83.33Z"
      style={{ fill: "url(#microsoft_excel__g)" }}
    />
    <rect
      height="166.67"
      rx="41.66"
      ry="41.66"
      style={{ fill: "url(#microsoft_excel__h)" }}
      width="208.29"
      x="277.71"
    />
    <rect
      height="222.22"
      rx="45.13"
      ry="45.13"
      style={{ fill: "url(#microsoft_excel__i)" }}
      width="222.17"
      y="236.11"
    />
    <rect
      height="222.22"
      rx="45.13"
      ry="45.13"
      style={{ fill: "url(#microsoft_excel__j)", fillOpacity: 0.3 }}
      width="222.17"
      y="236.11"
    />
    <path
      d="M169.48 410.71h-34.25l-21.5-40.47c-.77-1.42-1.36-2.54-1.77-3.37-.35-.88-.74-1.89-1.15-3.01h-.35c-.53 1.42-1.03 2.57-1.5 3.45-.47.89-1.03 1.98-1.68 3.28l-22.3 40.11h-32.3l38.76-63.58-36.1-63.4h33.8l19.11 36.13c.77 1.48 1.42 2.78 1.95 3.9.59 1.06 1.18 2.33 1.77 3.81h.35l1.95-4.07c.53-1 1.24-2.33 2.12-3.98l19.82-35.77h32.21l-36.63 62.43 37.7 64.55Z"
      style={{ fill: "#fff" }}
    />
  </svg>
);

export default MicrosoftExcel;
